import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import cardImg from "../../../assets/img/services/servicesFour/card-img.webp";

function ServicesFour() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div className="servicesFour">
        <div className="servicesFourText">
          <h1 className={`${isVisible ? "visible" : ""}`}>{t("services_four_title")}</h1>
          <h2 className={`${isVisible ? "visible" : ""}`}>
            {t("services_four_subtitle")}
          </h2>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("services_four_text")}
          </p>
        </div>
        <div className="servicesFourCards">
          <div className="cards1">
            <div className={`card card1 ${isVisible ? "visible" : ""}`}>
              <h3>{t("services_four_card1_title")}</h3>
              <p>
                {t("services_four_card1_text")}
              </p>
            </div>
          </div>
          <div className="cards2">
            <div className={`card card3 ${isVisible ? "visible" : ""}`}>
              <h3>{t("services_four_card2_title")}</h3>
              <p>
                {t("services_four_card2_text")}
              </p>
            </div>
            <img
              className={`cardImg ${isVisible ? "visible" : ""}`}
              src={cardImg}
              alt=""
            />
            <div className={`card card4 ${isVisible ? "visible" : ""}`}>
              <h3>{t("services_four_card3_title")}</h3>
              <p>
                {t("services_four_card3_text")}
              </p>
            </div>
          </div>
          <div className="cards3">
            <div className={`card card5 ${isVisible ? "visible" : ""}`}>
              <h3>{t("services_four_card4_title")}</h3>
              <p>
                {t("services_four_card4_text")}
              </p>
            </div>
            <div className={`card card6 ${isVisible ? "visible" : ""}`}>
              <h3>{t("services_four_card5_title")}</h3>
              <p>
                {t("services_four_card5_text")}
              </p>
            </div>
          </div>
        </div>
        <a
          className={`${isVisible ? "visible" : ""}`}
          href="/warehouseStructure"
          reloadDocument
        >
          <button>{t("services_four_btn")}</button>
        </a>
      </div>
    </VisibilitySensor>
  );
}

export default ServicesFour;
